import userProfileAction from 'images/sports/common/ic-cheer-action.png';
import userProfileCaster from 'images/sports/common/ic-cheer-caster.png';
import userProfileSystem from 'images/sports/common/ic-cheer-system.png';
import userProfileEvent from 'images/sports/common/ic-cheer-event.png';
import userJail from 'images/sports/common/level/jail.png';

const getUserProfileImageSrc = ({ admin, jail, type, profileImg }) => {
  if (admin) {
    switch (type) {
      case 'action':
        return userProfileAction;
      case 'event':
        return userProfileEvent;
      case 'system':
        return userProfileSystem;
      default:
        return userProfileCaster;
    }
  } else if (jail) {
    return userJail;
  } else {
    return profileImg;
  }
};

export default getUserProfileImageSrc;
